import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faWifi,
  faExclamationTriangle,
  faCheckCircle,
} from '@fortawesome/free-solid-svg-icons';
import { useOnlineStatus } from '../../../hooks/useOnlineStatus';
import './OfflineBanner.css';

/**
 * Offline Banner Component
 * Displays a banner when the user loses internet connection
 * Shows a brief "back online" message when connection is restored
 */
const OfflineBanner = () => {
  const { isOffline, wasOffline } = useOnlineStatus();

  // Show "back online" message briefly when connection is restored
  if (wasOffline && !isOffline) {
    return (
      <div className="offline-banner online-restored" role="status" aria-live="polite">
        <FontAwesomeIcon icon={faCheckCircle} className="offline-banner-icon" />
        <span className="offline-banner-message">
          You're back online!
        </span>
      </div>
    );
  }

  // Show offline banner when disconnected
  if (isOffline) {
    return (
      <div className="offline-banner" role="alert" aria-live="assertive">
        <FontAwesomeIcon icon={faExclamationTriangle} className="offline-banner-icon" />
        <span className="offline-banner-message">
          <FontAwesomeIcon icon={faWifi} className="offline-wifi-icon" />
          You're offline. Some features may not be available.
        </span>
        <span className="offline-banner-hint">
          Check your internet connection
        </span>
      </div>
    );
  }

  return null;
};

export default OfflineBanner;
